import React from 'react'
import PropTypes from 'prop-types'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'

const InternalMessageLayout = props => {
  const {
    children,
    title,
    selectedKey,
    linkToInternalMessageRecieve,
    linkToInternalMessageSend,
  } = props

  return (
    <>
      {title}
      <ContentBlockWrapper style={{ padding: '15px 0 ' }}>
        <Menu
          mode="horizontal"
          selectedKeys={[selectedKey]}
          style={{ marginBottom: 4, marginTop: 50 }}>
          <Menu.Item key="receive">
            <Link to={linkToInternalMessageRecieve}>Tin nhắn đến</Link>
          </Menu.Item>
          <Menu.Item key="send">
            <Link to={linkToInternalMessageSend}>Tin nhắn đi</Link>
          </Menu.Item>
        </Menu>
        {children}
      </ContentBlockWrapper>
    </>
  )
}

InternalMessageLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  selectedKey: PropTypes.string,
}

export default inject('aclStore')(observer(InternalMessageLayout))
